import axios from "axios";

export const newLogin = async (_id,email, username) => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}new-login`, {_id, email, username});
    // console.log(res.data)
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};